import type { CollageDocument } from './document';
import { validateDocument } from './schemas';

export function serializeDocument(document: CollageDocument): string {
  return JSON.stringify(validateDocument(document));
}

export function deserializeDocument(json: string): CollageDocument {
  let value: unknown;
  try {
    value = JSON.parse(json) as unknown;
  } catch {
    throw new Error('Project document is not valid JSON');
  }
  return validateDocument(value);
}
